import { render, staticRenderFns } from "./Brownie.vue?vue&type=template&id=57af8a2f&"
import script from "./Brownie.vue?vue&type=script&lang=js&"
export * from "./Brownie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports